import { render } from "./ReviewSentRequestPage.vue?vue&type=template&id=6f3448e2&scoped=true&ts=true"
import script from "./ReviewSentRequestPage.vue?vue&type=script&lang=ts"
export * from "./ReviewSentRequestPage.vue?vue&type=script&lang=ts"

import "./ReviewSentRequestPage.vue?vue&type=style&index=0&id=6f3448e2&lang=sass&scoped=true"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f3448e2"]])

export default __exports__